import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { Address } from '../../api/models/address';
import { Worksheet } from '../../api/models/worksheet';
import { MarketService } from '../../api/services/market.service';
import { ProjectService } from '../../api/services/project.services';
import { AddressCreationComponent } from '../address-creation/address-creation.component';

@Component({
  selector: 'app-order-address-change-modal',
  templateUrl: './order-address-change-modal.component.html',
  styleUrls: ['./order-address-change-modal.component.scss']
})
export class OrderAddressChangeModalComponent implements OnInit {

  worksheet: Worksheet;
  addresses: Address[];
  selectedAddressId: string;
  selectedAddress: Address;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private marketService: MarketService,
    private projectService: ProjectService) { }

  ngOnInit() {
    this.marketService.getAddresses(this.worksheet.project.marketId).subscribe(addresses => {
      this.addresses = addresses;
      this.setSiteAddress(this.worksheet.shipToAddressId);
    });
  }

  addAddress() {
    const modalRef = this.modalService.open(AddressCreationComponent, {
      backdrop: 'static',
      keyboard: false
    });

    modalRef.result
      .then(newAddress => {
        if (newAddress) {
          this.addresses.push(newAddress);
          this.setSiteAddress(newAddress.id);
        }
      })
      .catch(() => { });
  }

  setSiteAddress(addressId: string) {
    if (addressId) {
      this.selectedAddressId = addressId;
      this.selectedAddress = this.addresses.filter(a => a.id == addressId)[0];
    }
  }

  changeAddress() {
    this.worksheet.shipToAddressId = this.selectedAddressId;
    this.worksheet.confirmedShipToAddressId = true;
    this.projectService.updateWorksheet(this.worksheet.id, this.worksheet).subscribe(() => {
      this.activeModal.close(this.selectedAddressId);
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-address-change-modal/order-address-change-modal.component.ts